import { createFileRoute } from "@tanstack/react-router";
import { PaymentGatewaysAdmin } from "@/components/admin/payment-gateways-panels";

export const Route = createFileRoute("/_authenticated/admin/payment-gateways")({
  component: PaymentGatewaysAdmin,
});
